import { EventLineType, ImportExportEventType, ImportExportChartType } from "./constants";
import { exportHandlerCat2Edito, importFunctionCat2Edito } from "./importExportFunctions/importExportCat2Edito";
import { exportHandlerDanoni, importFunctionDanoni } from "./importExportFunctions/importExportDanoni";
import { exportHandlerDanoniSkbEditor, importFunctionDanoniSkbEditor } from "./importExportFunctions/importExportDanoniSkbEditor";
import { exportHandlerOsu, importFunctionOsu } from "./importExportFunctions/importExportOsu";

export async function exportToClipboard(dataStr) {
  try {
    await navigator.clipboard.writeText(dataStr);
    return null
  } catch (err) {
    return err
  }
}

export function exportToFile(title, dataStr, type) {
  try {
    const mimeType =
      type == ImportExportChartType.Cat2edito || type == ImportExportChartType.DanoniSkbEditor ? 'application/json'
        : type == ImportExportChartType.Osu ? 'application/x-osu-beatmap'
          : 'text/plain'

    const extension = type == 'osu' ? '.osu' : ''

    const blob = new Blob([dataStr], { type: mimeType });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = title + extension;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return null
  } catch (e) {
    return e
  }
}

export function identifyChartStrFormat(str) {
  if (typeof str !== 'string' || str == "") return null

  // if (str.startsWith("osu file format v14")) return ImportExportChartType.Osu
  if (str.match("\\|[a-zA-Z0-9]+_data=([0-9.]+(\\s*,\\s*[0-9.]+)*)") != null) return ImportExportChartType.Danoni

  let jsonObj
  try {
    jsonObj = JSON.parse(str);
  } catch (e) {
    return null
  }
  if (typeof jsonObj !== 'object') return null;
  if (["timings", "scores", "keyKind"].every(attr => Object.hasOwn(jsonObj, attr))) return ImportExportChartType.DanoniSkbEditor
  if (["eventLines", "columns"].every(attr => Object.hasOwn(jsonObj, attr))) return ImportExportChartType.Cat2edito

  return null
}

function getExportFunction(chartFormat) {
  switch (chartFormat) {
    // case ImportExportChartType.Osu:
    //   return exportHandlerOsu
    case ImportExportChartType.Danoni:
      return exportHandlerDanoni
    case ImportExportChartType.DanoniSkbEditor:
      return exportHandlerDanoniSkbEditor
    case ImportExportChartType.Cat2edito:
      return exportHandlerCat2Edito
    default:
      return null
  }
}

function getImportFunction(chartFormat) {
  switch (chartFormat) {
    // case ImportExportChartType.Osu:
    //   return importFunctionOsu
    case ImportExportChartType.Danoni:
      return importFunctionDanoni
    case ImportExportChartType.DanoniSkbEditor:
      return importFunctionDanoniSkbEditor
    case ImportExportChartType.Cat2edito:
      return importFunctionCat2Edito
    default:
      return null
  }
}

function chartToEventSequence(chartObj) {
  const res = []

  chartObj.orderedEventLines.value.forEach(eventLine => {
    res.push({ type: ImportExportEventType.EventLine, value: eventLine })
    if (eventLine.type === EventLineType.Timing) {
      const rbTree = chartObj.notesByEventLine.get(eventLine.eventLineId)
      for(const chord of rbTree.rangeQuery(-Infinity, Infinity)){
        chord.sort((x, y) => x.column.columnIndex - y.column.columnIndex).forEach(note => {
          res.push({ type: ImportExportEventType.Note, value: note })
        })
      }
    }
  })
  return res
}

export function exportChart(chartObj, exportFormat) {
  try {
    const handler = getExportFunction(exportFormat)
    if (handler == null || handler.finally == null)
      throw new Error(`Export function for chart format '${exportFormat}' not implemented, aborting export`)

    const eventSequence = chartToEventSequence(chartObj)

    // init
    const state = handler.init == null ? {} : handler.init(chartObj)

    // process events
    if (handler.processEvent != null) {
      for (let i = 0; i < eventSequence.length; i++) {
        const end = handler.processEvent(eventSequence[i], state, chartObj)
        if (end)
          break;
      }
    }

    // finally
    const result = handler.finally(state, chartObj)
    if (typeof result !== 'string') {
      throw new Error(`Error: export function resulting value was not a string: '${result}'`)
    }

    return [result, null]

  } catch (e) {
    return [null, e]
  }
}

export function importChart(chartObj, chartStr, importFormat = null) {
  try {
    if (importFormat == null) {
      importFormat = identifyChartStrFormat(chartStr)
      if (importFormat == null) {
        throw new Error(`Error: was unable to identify shart format, aborting import`)
      }
    }

    const func = getImportFunction(importFormat)
    if (func == null) {
      throw new Error(`Import function for chart format '${importFormat}' not implemented, aborting import`)
    }

    func(chartObj, chartStr)
    return null
  } catch (e) {
    return e
  }
}